import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { AuditLogFilters, AuditLogPage } from '../types/audit-log'

export async function getAuditLogs(filters: AuditLogFilters): Promise<AuditLogPage> {
  const params = new URLSearchParams()
  params.set('page', String(filters.page))
  params.set('size', String(filters.size))

  if (filters.action) params.set('action', filters.action)
  if (filters.entityType) params.set('entityType', filters.entityType)
  if (filters.search) params.set('search', filters.search)
  if (filters.from) params.set('from', filters.from)
  if (filters.to) params.set('to', filters.to)

  const response = await api.get<ApiResponse<AuditLogPage>>(`/api/audit-logs?${params}`)
  return response.data.data
}
